import { useAppDispatch } from "../../hooks";
import ModalDialog from "./ModalDialog";
import styled from "@emotion/styled";
import { closePrivacyPolicyDialog } from "../../features/privacyPolicy/privacyPolicySlice";
import t from "../../helper/t";
import SmartLink from "./SmartLink";

import imageCloseSvg from "../../../public/img/icons/close_black_round.svg";
import imageInfoSvg from "../../../public/img/icons/info-circle-red.svg";


const RootDiv = styled.div([
    {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
    }
])

const CloseButtonDiv = styled.div([
    {
        alignSelf: "end",
        cursor: "pointer",
    }
]);

const TitleDiv = styled.div([
    props => props.theme.typography.bold32,
    props => props.theme.colors.foreground.primary,
    {
        marginTop: 18,
    }
]);

const BodyDiv = styled.div([
    props => props.theme.typography.regular20,
    props => props.theme.colors.foreground.primary,
    {
        lineHeight: "32px",
        marginTop: 40,
    }
]);

const PrivacyPolicyDialog: React.FC<{}> = () => {
    const dispatch = useAppDispatch();

    const onClose = () => {
        dispatch(closePrivacyPolicyDialog("False"));
    }

    const onStart = () => {
        dispatch(closePrivacyPolicyDialog("True"));
    }

    return (
        <ModalDialog roundBorder={false} maxWidth={860}>
            <RootDiv>
                <CloseButtonDiv onClick={onClose}>
                    <img src={imageCloseSvg.src} alt="close" />
                </CloseButtonDiv>

                <img style={{ marginTop: -8 }} src={imageInfoSvg.src} alt="info" />

                <TitleDiv>
                    {t("Hinweis")}
                </TitleDiv>

                <BodyDiv>
                    {t("Mit dem Klick auf den “Start”-Knopf bestätigst Du, dass Du die")}
                    <br />
                    <SmartLink href="/privacy_policy_faq" target="_blank" isNaked={false}>
                        {t("Bestimmungen zum Datenschutz")}
                    </SmartLink>
                    <br />
                    {t("gelesen und akzeptiert hast und insbesondere in die Nutzung")}
                    <br />
                    {t("der im Rahmen der Messung erhobenen Daten einwilligst.")}
                </BodyDiv>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: 40,
                    marginBottom: 90
                }}>
                    <SmartLink href="/speedtest" onClick={onStart}>
                        <div className="button-rectangle-left rectangle-grey">
                            <div data-cy="button-tips" className="button-rectangle-text white-label">
                                {t("Speedtest Plus starten")}
                            </div>
                        </div>
                    </SmartLink>
                </div>
            </RootDiv>
        </ModalDialog>
    );

}

export default PrivacyPolicyDialog;